import { render, staticRenderFns } from "./userMsgPopover.vue?vue&type=template&id=7bf13a9b&scoped=true"
import script from "./userMsgPopover.vue?vue&type=script&lang=js"
export * from "./userMsgPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf13a9b",
  null
  
)

export default component.exports